.container {
  padding: var(--mantine-spacing-xs) 0;
}

.chip {
  font-weight: calc(var(--mantine-heading-font-weight) * 0.714);
}
